































































































import {Vue, Component, PropSync, Watch} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {dp2Type} from "@/store/push/application/types";
import { InputWings } from "wings-ui-components";

@Component({components: {proxySettingsForm, InputWings}})
export default class Dp2Settings extends Vue {
  @PropSync('dp2Options') dp2!: dp2Type;
  private isProxySettings: boolean = false;

  created() {
    if(this.dp2.proxy_settings_name) this.isProxySettings = true;
  }

  @Watch('isProxySettings')
  onChangeProxy(newValue: boolean) {
    if (!newValue) this.dp2.proxy_settings_id = undefined;
  }
}
